export const MANAGER_COMMAND_CENTER_ERROR_CONFIG = {
  appName: 'ui-shell',
  source: 'useManagerCommandCenter',
  stream: 'readiness',
  projectType: 'learner',
};
